import { faGaugeHigh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Dispatch, useEffect, useState } from "react";
import "../../App.css";
import { useTheme } from "../../theme/ThemeContext";

type SensorButtonPropTypes = {
  closePopupDropDown: (open: boolean) => void;
  showPopupDropDownSensor: boolean;
  getOpenMenu:string;
  openLayerTypeMap: Map<string, boolean>;
  openPopupDropDown: (open: boolean) => void;
};

const SensorButton = ({
  closePopupDropDown,
  showPopupDropDownSensor,
  getOpenMenu,
  openLayerTypeMap,
  openPopupDropDown
}: SensorButtonPropTypes) => {
  const [isClicked, setIsClicked] = useState<boolean>(true);
  const [hoveredSensor, setHoveredSensor] = useState<boolean>(false);
  const { theme } = useTheme();

  const handleButtonClick = () => {
    setIsClicked((prevState) => !prevState);
  };

  useEffect(() => {
    if (!isClicked) {
      closePopupDropDown(true);
    } else {
      openLayerTypeMap.forEach((value, key) => {
        if (value === true) {
          if (key !== "river" && key !== "airquality" && key !== "rain" ) {
            openPopupDropDown(false);
          } 
        }
      });
    }
  }, [isClicked]);

  useEffect(() => {
    if (!showPopupDropDownSensor) {
      setIsClicked(true);
    }
  }, [showPopupDropDownSensor]);

  useEffect(() => {}, [getOpenMenu]);

    useEffect(() => {
      openLayerTypeMap.forEach((value, key) => {
        if (value === true) {
          if (key === "river" ||key === "airquality" || key === "rain" ) {
           setIsClicked(false);
          } 
        }
      });
    }, []);

  return (
    <>
       <div className="leftsidemenulist-btn-cover" onClick={handleButtonClick} onTouchStart={handleButtonClick}>
              <div
                onMouseEnter={() => setHoveredSensor(true)}
                onMouseLeave={() => setHoveredSensor(false)}
                className="leftsidemenulist-btns"
              >
                <FontAwesomeIcon size="1x" icon={faGaugeHigh} className="leftside-icon" />
              </div>
              {theme === "light" && (
              <div
                className={
                  isClicked
                    ? hoveredSensor
                      ? "leftsidemenulist-btn-tooltip-hover-light"
                      : "leftsidemenulist-btn-tooltip-light"
                    : "leftsidemenulist-btn-tooltip-clicked-light"
                }
                onMouseEnter={() => setHoveredSensor(true)}
                onMouseLeave={() => setHoveredSensor(false)}
              >
               Sensors
              </div>
              )}
               {theme !== "light" && (
              <div
                className={
                  isClicked
                    ? hoveredSensor
                      ? "leftsidemenulist-btn-tooltip-hover"
                      : "leftsidemenulist-btn-tooltip"
                    : "leftsidemenulist-btn-tooltip-clicked"
                }
                onMouseEnter={() => setHoveredSensor(true)}
                onMouseLeave={() => setHoveredSensor(false)}
              >
               Sensors
              </div>
               )}
            </div>
    </>
  );
};

export default SensorButton;
